module.exports = __webpack_public_path__ + "static/media/message-icon.75078658.svg";